var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "rgba(255, 255, 255, 0)",
      display: "block"
    },
    width: "200px",
    height: "200px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 50,
    fill: "#f8f9f9",
    r: 5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "3;3;5;3;3",
    times: "0;0.1;0.2;0.3;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "-0.9166666666666666s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#f8f9f9;#f8f9f9;#7eb0c1;#f8f9f9;#f8f9f9",
    repeatCount: "indefinite",
    times: "0;0.1;0.2;0.3;1",
    dur: "1s",
    begin: "-0.9166666666666666s"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 71.65063509461098,
    cy: 62.5,
    fill: "#f8f9f9",
    r: 5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "3;3;5;3;3",
    times: "0;0.1;0.2;0.3;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "-0.8333333333333334s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#f8f9f9;#f8f9f9;#7eb0c1;#f8f9f9;#f8f9f9",
    repeatCount: "indefinite",
    times: "0;0.1;0.2;0.3;1",
    dur: "1s",
    begin: "-0.8333333333333334s"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 71.65063509461096,
    fill: "#f8f9f9",
    r: 5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "3;3;5;3;3",
    times: "0;0.1;0.2;0.3;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "-0.75s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#f8f9f9;#f8f9f9;#7eb0c1;#f8f9f9;#f8f9f9",
    repeatCount: "indefinite",
    times: "0;0.1;0.2;0.3;1",
    dur: "1s",
    begin: "-0.75s"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 75,
    fill: "#f8f9f9",
    r: 5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "3;3;5;3;3",
    times: "0;0.1;0.2;0.3;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "-0.6666666666666666s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#f8f9f9;#f8f9f9;#7eb0c1;#f8f9f9;#f8f9f9",
    repeatCount: "indefinite",
    times: "0;0.1;0.2;0.3;1",
    dur: "1s",
    begin: "-0.6666666666666666s"
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.50000000000001,
    cy: 71.65063509461098,
    fill: "#f8f9f9",
    r: 5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "3;3;5;3;3",
    times: "0;0.1;0.2;0.3;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "-0.5833333333333334s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#f8f9f9;#f8f9f9;#7eb0c1;#f8f9f9;#f8f9f9",
    repeatCount: "indefinite",
    times: "0;0.1;0.2;0.3;1",
    dur: "1s",
    begin: "-0.5833333333333334s"
  }))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.34936490538903,
    cy: 62.5,
    fill: "#f8f9f9",
    r: 5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "3;3;5;3;3",
    times: "0;0.1;0.2;0.3;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "-0.5s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#f8f9f9;#f8f9f9;#7eb0c1;#f8f9f9;#f8f9f9",
    repeatCount: "indefinite",
    times: "0;0.1;0.2;0.3;1",
    dur: "1s",
    begin: "-0.5s"
  }))), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 50,
    fill: "#f8f9f9",
    r: 5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "3;3;5;3;3",
    times: "0;0.1;0.2;0.3;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "-0.4166666666666667s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#f8f9f9;#f8f9f9;#7eb0c1;#f8f9f9;#f8f9f9",
    repeatCount: "indefinite",
    times: "0;0.1;0.2;0.3;1",
    dur: "1s",
    begin: "-0.4166666666666667s"
  }))), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.34936490538903,
    cy: 37.50000000000001,
    fill: "#f8f9f9",
    r: 5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "3;3;5;3;3",
    times: "0;0.1;0.2;0.3;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "-0.3333333333333333s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#f8f9f9;#f8f9f9;#7eb0c1;#f8f9f9;#f8f9f9",
    repeatCount: "indefinite",
    times: "0;0.1;0.2;0.3;1",
    dur: "1s",
    begin: "-0.3333333333333333s"
  }))), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.499999999999986,
    cy: 28.34936490538904,
    fill: "#f8f9f9",
    r: 5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "3;3;5;3;3",
    times: "0;0.1;0.2;0.3;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "-0.25s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#f8f9f9;#f8f9f9;#7eb0c1;#f8f9f9;#f8f9f9",
    repeatCount: "indefinite",
    times: "0;0.1;0.2;0.3;1",
    dur: "1s",
    begin: "-0.25s"
  }))), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.99999999999999,
    cy: 25,
    fill: "#f8f9f9",
    r: 5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "3;3;5;3;3",
    times: "0;0.1;0.2;0.3;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "-0.16666666666666666s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#f8f9f9;#f8f9f9;#7eb0c1;#f8f9f9;#f8f9f9",
    repeatCount: "indefinite",
    times: "0;0.1;0.2;0.3;1",
    dur: "1s",
    begin: "-0.16666666666666666s"
  }))), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 28.349364905389034,
    fill: "#f8f9f9",
    r: 5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "3;3;5;3;3",
    times: "0;0.1;0.2;0.3;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "-0.08333333333333333s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#f8f9f9;#f8f9f9;#7eb0c1;#f8f9f9;#f8f9f9",
    repeatCount: "indefinite",
    times: "0;0.1;0.2;0.3;1",
    dur: "1s",
    begin: "-0.08333333333333333s"
  }))), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 71.65063509461096,
    cy: 37.499999999999986,
    fill: "#f8f9f9",
    r: 5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "3;3;5;3;3",
    times: "0;0.1;0.2;0.3;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "0s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#f8f9f9;#f8f9f9;#7eb0c1;#f8f9f9;#f8f9f9",
    repeatCount: "indefinite",
    times: "0;0.1;0.2;0.3;1",
    dur: "1s",
    begin: "0s"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/Loader.c5aa819a2fb7133937db5de6c0ef490e.svg";
export { ForwardRef as ReactComponent };